export const becomeMemberData = [
    {
      type: "Standard",
      price: 10,
      benefit: ["50GB Disk Space", "50 Email Accounts", "Maintenance", "15 Subdomains"],
    },
    {
      type: "Premium",
      price: 20,
      benefit: ["10% on all product", "50 Email Accounts", "Maintenance", "15 Subdomains"],
    },
    {
      type: "Author pack",
      price: 50,
      benefit: ["Upload 50 product", "50 Email Accounts", "Maintenance", "15 Subdomains"],
    },
    {
      type: "Author pack",
      price: 50,
      benefit: ["Upload 50 product", "50 Email Accounts", "Maintenance", "15 Subdomains"],
    },
  ];

  export const simplePricingData = [
    {
      title: "Standard",
      price: 15,
      plan: "Standard Plan",
    },
    {
      title: "Business",
      price: 25,
      plan: "Business Plan",
    },
    {
      title: "Premium",
      price: 35,
      plan: "Premium Plan",
    },
    {
      title: "Extra",
      price: 45,
      plan: "Extra Plan",
    },
  ];